const SEO = {
  defaultTitle: 'Iron',
  titleTemplate: '%s | Iron',
  description: 'Iron, yield, leverage, limit, launch all on one community driven ecosystem',
  openGraph: {
    type: 'website',
    url: 'https://app.ironproject.org',
    site_name: 'Iron',
  },
  twitter: {
    handle: '@ironprojectorg',
    site: '@ironprojectorg',
    cardType: 'summary_large_image',
  },
}

export default SEO
